import { useQuery } from "@tanstack/react-query";
import ThemeDropDown from "../ThemeDropDown";
import React, { useEffect, useState } from "react";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import { Col, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setUserClearFilter,
  setValanValue,
} from "../../store/slice/globleSlice";
import useGetQueryParams from "../../hooks/useGetQueryParams";

const ValanComponant = React.memo(({ valueRef, setGetValan }) => {
  // state
  const [valanOption, setValanOption] = useState([]);
  const [value, setValue] = useState(null);
  const { params, setSearchParams } = useGetQueryParams();
  const dispatch = useDispatch();

  // redux
  const resetValan = useSelector((state) => state.globleSlice?.userClearFilter);
  const setValan = useSelector((state) => state.globleSlice?.clearValan);
  const loginId = useSelector((state) => state.authSlice?.userDetail?.userId);

  // api
  const getValanList = async () => {
    let response = await APICall("get", EndPoints.getValanList);
    return response?.data?.data?.valanList;
  };
  const {
    isLoading: valanLoading,
    error: valanError,
    data: valanData,
  } = useQuery({ queryKey: ["getValan"], queryFn: getValanList });

  if (valanError) {
    notification.error({ message: valanError?.message });
  }

  // life cycle
  useEffect(() => {
    if (params?.valan) {
      setValue(params?.valan);
      valueRef.current = {
        ...valueRef.current,
        valan: params?.valan,
      };
    }
  }, []);

  useEffect(() => {
    if (resetValan) {
      setValue(valanOption[0]?.value);
      valueRef.current = { ...valueRef.current, valan: valanOption[0]?.value };
      dispatch(setUserClearFilter(false));
    }
  }, [resetValan]);

  useEffect(() => {
    if (valanData) {
      const finalValan = valanData.map((el) => {
        return { label: el?.valanName, value: el?._id };
      });
      setValanOption(finalValan);
      if (!params?.valan) {
        valueRef.current = {
          ...valueRef.current,
          valan: finalValan?.[0]?.value,
        };
        if (setGetValan) {
          setGetValan(true);
        }
        setValue(finalValan?.[0]?.value);
        // setSearchParams({
        //   userId: loginId,
        //   valan: finalValan?.[0]?.value,
        //   ...params,
        // });
      }
    }
  }, [valanData]);

  useEffect(() => {
    if (!setValan) {
      setValue(null);
      valueRef.current = { ...valueRef.current, valan: null };
    }
  }, [setValan]);

  // function
  const onChangeDropDown = (name, value, options) => {
    setValue(value?.[0] ? value[0] : null);
    valueRef.current = {
      ...valueRef.current,
      valan: value?.[0] ? value[0] : null,
      startDate: null,
      endDate: null,
    };
    dispatch(setValanValue(true));
  };

  return (
    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
      <ThemeDropDown
        title={"Valan"}
        placeholder="Valan"
        name="valan"
        width={"98%"}
        options={valanOption}
        $onChange={onChangeDropDown}
        value={value}
        loadings={valanLoading ? "true" : "false"}
        // suffixIcon={<Spin size="small" spinning={valanLoading} />}
        // disabled={valanLoading}
      />
    </Col>
  );
});

export default ValanComponant;
